import * as React from 'react';
import { Box, CustomModalLayout, ModalMobileLayout, Button, } from '@wix/design-system';
import { ReviewAppHeader } from './review-app-header';
import { ReviewAppForm } from './review-app-form';
import { useReviewForm } from '../../hooks/useReviewForm';
import { biLogger } from '../../bi';
import { ReviewAppHeaderMobile } from './review-app-header-mobile';
import { appMarketPostAppReview, appMarketCancelAppReviewClick, } from '@wix/bi-logger-market/v2';
function ReviewAppModalLayout({ appDefId, appName, appIconSrc, previousReview, closeModal, afterClose, showSuccessToast, additionalBiData, t, isMobile, }) {
    const submitReviewButtonText = t('review-app.submit-review');
    const cancelButtonText = t('review-app.cancel-review');
    function onSuccessfulSubmission(reviewData) {
        closeModal();
        showSuccessToast?.(t('review-app.successful-submission-toast'));
        afterClose?.();
        biLogger
            .report(appMarketPostAppReview({
            appId: appDefId,
            msid: additionalBiData.msid,
            appScore: reviewData.rating.toString(),
            review_title: reviewData.title,
            has_description: Boolean(reviewData.description),
            review_body: reviewData.description,
            actionType: previousReview?.reviewId ? 'edit_review' : 'add_review',
            post_type: 'new_review',
            tag_type: additionalBiData.tagType,
            market: additionalBiData.platform,
        }))
            .catch((error) => console.log(error));
    }
    const reviewForm = useReviewForm(appDefId, previousReview, onSuccessfulSubmission);
    function closeModalAndSendBi() {
        closeModal();
        biLogger
            .report(appMarketCancelAppReviewClick({
            appId: appDefId,
            msid: additionalBiData.msid,
            tag_type: additionalBiData.tagType,
            market: additionalBiData.platform,
        }))
            .catch((error) => console.log(error));
    }
    return isMobile ? (React.createElement(ModalMobileLayout, { fullscreen: true, title: React.createElement(ReviewAppHeaderMobile, { appName: appName, appIconSrc: appIconSrc, t: t }), content: React.createElement(ReviewAppForm, { appName: appName, reviewForm: reviewForm, t: t }), footer: React.createElement(Box, { align: "right" },
            React.createElement(Box, { marginRight: "12px" },
                React.createElement(Button, { priority: "secondary", onClick: closeModalAndSendBi }, cancelButtonText)),
            React.createElement(Button, { onClick: reviewForm.submit }, submitReviewButtonText)), onCloseButtonClick: closeModalAndSendBi })) : (React.createElement(CustomModalLayout, { width: "600px", height: "544px", title: React.createElement(ReviewAppHeader, { appName: appName, appIconSrc: appIconSrc, t: t }), primaryButtonText: submitReviewButtonText, primaryButtonOnClick: reviewForm.submit, secondaryButtonText: cancelButtonText, secondaryButtonOnClick: closeModalAndSendBi, onCloseButtonClick: closeModalAndSendBi },
        React.createElement(ReviewAppForm, { appName: appName, reviewForm: reviewForm, t: t })));
}
export { ReviewAppModalLayout };
//# sourceMappingURL=review-app-modal-layout.js.map